<script lang="ts" setup>
import { getDate, getVariantShippingDaysDifference } from '../../utils/helpers';
import type { ProductVariant, VariantWithDate } from '~/types/Product.ts';
import { useCountryCode } from '~/stores/country.ts';

interface EstimatedShippingDateProps {
	handlingDate: string;
	selectedVariantData: ProductVariant;
	defaultDate: string;
}
const props = defineProps<EstimatedShippingDateProps>();
const CountryStore = useCountryCode();
const { deliverToCountry } = storeToRefs(CountryStore);
const variantsWithDates: Ref<VariantWithDate[]> = inject('variantsWithDates')!;
const { storeType } = useGlobalStore();
const productDate: Ref<string> = inject('productDate')!;

const remainingDays = ref<number | null>(null);

const globalCutoffConfig = inject('globalCutoffConfig') as any;

const showBanner = computed(() => {
	if (
		globalCutoffConfig.value &&
		storeType === 'MARKETPLACE' &&
		!globalCutoffConfig.value?.excluded_countries?.includes(
			deliverToCountry.value,
		)
	) {
		const date = new Date();

		if (globalCutoffConfig.value?.[deliverToCountry.value]) {
			const countryData = globalCutoffConfig.value?.[deliverToCountry.value];
			const skynetCutoff = new Date(countryData['skynet']);
			const fedexCutoff = new Date(countryData['fedex']);
			const dhlCutoff = new Date(countryData['dhl']);
			if (date < skynetCutoff) {
				return true;
			} else if (date < fedexCutoff) {
				return true;
			} else if (date < dhlCutoff) {
				return true;
			}
		} else {
			const targetDate = globalCutoffConfig.value?.['rest_of_world'];
			return date < new Date(targetDate);
		}
		return false;
	}
	return false;
});

watch(
	() => props.selectedVariantData,
	(newVal: ProductVariant) => {
		if (variantsWithDates.value.length && Object.keys(newVal || {}).length) {
			const date = variantsWithDates.value.find(
				(item) => item!.variant === newVal.title,
			)?.shippingDate;
			if (date) calculateShippingDate(date);
		}
	},
);

const calculateShippingDate = (date: string) => {
	productDate.value = getDate(date);
	remainingDays.value = getVariantShippingDaysDifference(date);
};

onMounted(() => {
	calculateShippingDate(props.defaultDate);
});

onBeforeMount(() => {
	calculateShippingDate(props.defaultDate);
});
</script>

<template>
	<div class="pdp__shipping-estimated-shipping-date gap-xl flex flex-col">
		<span class="text-md lg:text-lg font-semibold text-gray-800">Shipping</span>
		<!-- <Tabs default-value="pakistan" class="gap-xl flex flex-col">
			<TabsList
				class="gap-xs [&>*]:px-xl [&>*]:py-md [&>*]:rounded-small [&>*]: p-xs !rounded-large border border-solid border-gray-200 bg-gray-50 grid grid-cols-2"
			>
				<TabsTrigger
					value="pakistan"
					class="data-[state=active]:text-gray-700 text-gray-500"
				>
					Pakistan
				</TabsTrigger>
				<TabsTrigger
					value="international"
					class="data-[state=active]:text-gray-700 text-gray-500"
				>
					International
				</TabsTrigger>
			</TabsList>

			<TabsContent value="pakistan">
				<div
					class="p-xl rounded-medium bg-gray-50 flex flex-col w-full text-sm border border-gray-200 border-solid"
				>
					<span
						v-if="Math.abs(remainingDays()) <= 1"
						class="text-sm font-medium text-gray-700"
						>Express Shipping</span
					>
					<span v-else class="text-sm font-medium text-gray-700"
						>Standard Shipping</span
					>

					<div class="gap-xs flex w-full text-sm text-gray-600">
						<span class="">Estimated Shipping Date:</span>
						<span class="font-semibold">{{ handlingDate }}</span>
					</div>
				</div>
			</TabsContent>
			<TabsContent value="international">
				Change your password here.
			</TabsContent>
		</Tabs> -->

		<div
			class="p-3xl rounded-medium lg:rounded-xl flex flex-col w-full text-sm bg-white border border-gray-800"
		>
			<span v-if="remainingDays! < 2" class="text-sm font-medium text-gray-700">
				Express Shipping
			</span>
			<span v-else class="text-sm font-medium text-gray-700">
				Standard Shipping
			</span>
			<div class="gap-xs flex text-sm text-gray-600">
				<span>Estimated Shipping Date:</span>
				<span class="date font-semibold">{{ productDate }}</span>
			</div>
			<div
				v-if="showBanner"
				class="gap-xs flex font-normal text-sm text-gray-600"
			>
				<span>Order now for</span>
				<span class="date font-semibold">guaranteed</span>
				<span>Eid delivery!</span>
			</div>
		</div>
	</div>
</template>
